import { render } from "./MessagesWindow.vue?vue&type=template&id=c70d86d4&scoped=true&ts=true"
import script from "./MessagesWindow.vue?vue&type=script&lang=ts"
export * from "./MessagesWindow.vue?vue&type=script&lang=ts"

import "./MessagesWindow.vue?vue&type=style&index=0&id=c70d86d4&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70d86d4"]])

export default __exports__